module.exports = __webpack_public_path__ + "static/rivdev-67f55a3dd57d115b1fe5b0f84d71df05.png";